export const CATERING_SETUP_TIME_MIN = 0;
export const CATERING_SETUP_TIME_MAX = 240;

export const CATERING_SETUP_TIME_SUMMARY = 'Pickup is scheduled this many minutes earlier, and cannot be more than 240.';

export const CATERING_SETUP_TIME_DETAIL = 'This is added to drive time for scheduled catering deliveries. Orders in Unpaid, Needs Approval, New, or Processing use the new value the next time they are saved. Accepted or dispatched orders keep their current pickup time.';

export function cateringSetupTimeError(value) {
  if (value === null || value === undefined || value === '') {
    return 'Enter a whole number of minutes.';
  }
  if (typeof value === 'string' && !/^\d+$/.test(value.trim())) {
    return 'Enter a whole number of minutes.';
  }
  const minutes = typeof value === 'string' ? Number(value) : value;
  if (typeof minutes !== 'number' || !Number.isInteger(minutes)) {
    return 'Enter a whole number of minutes.';
  }
  if (minutes < CATERING_SETUP_TIME_MIN || minutes > CATERING_SETUP_TIME_MAX) {
    return 'Enter a whole number from 0 to 240.';
  }
  return null;
}

export function firstErrorText(message, fallback = 'Could not save catering setup time.') {
  const parts = Array.isArray(message) ? message : [message];
  const first = parts.find((item) => typeof item === 'string' && item.trim());
  return first ? first.trim() : fallback;
}
